import React from 'react'

import { Formik } from 'formik'
import * as FormGroups from './formGroups'

import { Modal, Row, Col, Button } from '_zari/core'
import { ZariContext } from '_zari/context'

import * as AsientoContableService from 'services/asientosContables.service'


const PasswordModal = ({ show, handleClose }) => {

    const __zariContext = React.useContext(ZariContext)

    const formInitialValues = React.useMemo(() => {
        return {
            password: ''
        }
    }, [])

    const onSubmit = React.useCallback(
        (data, { setSubmitting }) => {
            AsientoContableService.validarPasswordVistaAdmin(data)
                .then(({ data }) => {
                    setSubmitting(false)
                    if (data) {
                        handleClose()
                    } else {
                        __zariContext.snack('error', "Contraseña incorrecta, intente nuevamente.")
                    }
                })
                .catch(({ data: { error } }) => {
                    setSubmitting(false)
                    __zariContext.snack('error', error)
                })
        },
        [__zariContext, handleClose]
    )

    return (
        <Modal size='sm' show={show}>
            <Modal.Body>
                <Row>
                    <Col md={12}>
                        <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
                            {({ errors, touched, isSubmitting, handleSubmit }) => (
                                <>
                                    <FormGroups.PasswordFormGroup
                                        iError={errors.serieDocumento}
                                        iTouched={touched.serieDocumento}
                                        fIsSubmitting={isSubmitting}
                                    />
                                    <Row>
                                        <Col md={12} className='text-right'>
                                            <Button disabled={isSubmitting} onClick={handleSubmit}>
                                                Enviar
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default React.memo(PasswordModal)
